import React from 'react';
import { DialogContent } from '@material-ui/core';

const ResponsiveDialogContent: React.FC = ({ children }) => {
  return (
    <DialogContent>
      {children}
    </DialogContent>
  )
}

export default ResponsiveDialogContent;
